export interface ProblemRisk {
  title: string
  body: string
}

export const problemRisks: ProblemRisk[] = [
  {
    title: 'Se rompen',
    body: 'Pétalos que se quiebran al manipularlos o flores demasiado gruesas que nunca iban a servir para prensar.',
  },
  {
    title: 'Pierden el color',
    body: 'Rosas que salen marrones y violetas que se van al gris, porque el secado fue demasiado lento.',
  },
  {
    title: 'Se manchan',
    body: 'Humedad atrapada, papel equivocado y manchas u hongo que aparecen recién al abrir la prensa.',
  },
  {
    title: 'Se deforman',
    body: 'Presión desigual, flores arrugadas y composiciones que no se pueden enmarcar prolijas.',
  },
  {
    title: 'Perdés tiempo y materiales',
    body: 'Semanas de espera, marcos y papeles comprados, y una tanda entera que termina en la basura.',
  },
]

export const problemAnswers: string[] = [
  'Qué flores elegir (y cuáles descartar antes de perder tiempo)',
  'Cómo conservar la forma y el color original',
  'Cómo evitar los errores más comunes a tiempo',
  'Cómo transformarlas en piezas decorativas reales',
]
